export function evaluateAccessValue(accessValue, authorities) {
    if (accessValue.any &&
        accessValue.any.length > 0 &&
        accessValue.except &&
        accessValue.except.length > 0) {
        throw new Error('Access value cannot have both any and except properties');
    }
    return (!(accessValue.except === '*' ||
        (accessValue.except || []).some(function (authority) {
            return authorities.some(function (a) { return a === authority; });
        })) &&
        (!accessValue.any ||
            accessValue.any === '*' ||
            accessValue.any.some(function (authority) { return authorities.some(function (a) { return a === authority; }); })));
}
export function accessConfigToAllowedAccessMap(accessConfig, user) {
    return Object.entries(accessConfig).reduce(function (accessMap, _a) {
        var accessKey = _a[0], accessValue = _a[1];
        accessMap[accessKey] = evaluateAccessValue(accessValue, user.authorities);
        return accessMap;
    }, {});
}
